import { Button, Drawer, Form, FormInstance, Space } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { ZObjState } from "src/types/ZObjState";
import { ZUid } from "src/types/zUid";
import { KeepSelected } from "../tables/KeepSelected";
import { EntitySelectTableStore } from "./EntitySelectTableStore";
import styles from "./EntitySelectTable.module.less";

interface PropsEntitySelectTable {
  store: EntitySelectTableStore;
  label: string;
  form: FormInstance;
  disabled?: boolean;
  value?: string[];
  makeTag?: (id: ZUid) => React.ReactNode;
  statesLoader?: (() => Promise<ZObjState[]>) | undefined;
}

export const EntitySelectTable: React.FC<PropsEntitySelectTable> = observer(
  ({ store, value, disabled, label, form, statesLoader, makeTag }) => {
    const { open, filtersPageStore } = store;
    const safeValues = value || [];

    const filterField: string[] | null | undefined = Form.useWatch(
      String(store.filter?.id),
      form,
    );

    const handleClose = () => store.handleCancel();
    const handleOk = () => store.handleOk();

    useEffect(() => {
      if (filterField) {
        store.addFilters(form);
      }
    }, [filterField]);

    useEffect(() => {
      store.setValues(safeValues);
    }, [value]);

    useEffect(() => {
      if (open) {
        store.setInitialValues(safeValues);
      }
    }, [open]);

    useEffect(() => {
      if (store.filtersPageStore?.tableStore) {
        store.initSelected(safeValues);
      }
    }, [store.filtersPageStore?.tableStore]);

    if (!filtersPageStore) return null;
    const { tableStore } = filtersPageStore;

    return (
      <Drawer
        width="75vw"
        open={open && !disabled}
        onClose={handleClose}
        className={styles.drawer}
        title={label}
        extra={
          <Space>
            <Button onClick={handleClose}>{t("Cancel")}</Button>
            <Button type="primary" onClick={handleOk}>
              {t("Save")}
            </Button>
          </Space>
        }
      >
        <div className={styles.drawerContent}>
          {tableStore && makeTag && (
            <KeepSelected
              store={tableStore}
              makeTag={({ id }) => makeTag(id)}
              placeholder={t("Selected positions")}
            />
          )}
          <EntityFiltersTable
            store={filtersPageStore}
            statesLoader={statesLoader}
          />
        </div>
      </Drawer>
    );
  },
);
